import Seo from "@/components/Seo";
import { PageHero, Btn, QUALITE_LABEL, NDA_LABEL } from "@/components/Shared";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = [
  {
    q: "Vos formations sont-elles finançables par mon OPCO ?",
    a: `Pas encore, et nous préférons vous le dire clairement. ${QUALITE_LABEL} Objectif : fin 2026.`,
  },
  {
    q: "Form Action Pro est-il un organisme de formation déclaré ?",
    a: `Oui. ${NDA_LABEL}`,
  },
  {
    q: "Proposez-vous la formation réglementaire de 14 h en hygiène alimentaire ?",
    a: "Non, pas à ce jour. Cette formation (article L.233-4 du code rural et de la pêche maritime) est réservée depuis le 1er février 2026 aux organismes autorisés par la DRAAF. Notre dossier d’autorisation a été déposé auprès de la DRAAF en mai 2026 ; il est recevable et en attente de la certification qualité. Objectif : autorisation et référencement ROFHYA fin 2026. En attendant, nous proposons une action de perfectionnement en hygiène alimentaire et Plan de Maîtrise Sanitaire.",
  },
  {
    q: "Où se déroulent les formations ?",
    a: "Form Action Pro est basé à La Croix Valmer (Var). Les interventions ont lieu dans toute la France : dans vos locaux, dans un lieu adapté, ou en distanciel selon la formation.",
  },
  {
    q: "Quels sont les délais d’organisation ?",
    a: "Le délai d’accès indicatif est de 15 jours ouvrés à compter de votre accord. Il peut être plus court selon le calendrier — demandez, nous répondons franchement.",
  },
  {
    q: "Quels sont vos tarifs ?",
    a: "Toutes nos prestations sont sur devis, car chaque action est conçue sur mesure (durée, nombre de participants, lieu, contenu). Devis sous 48 h ouvrées, sans engagement.",
  },
  {
    q: "Vos formations sont-elles accessibles aux personnes en situation de handicap ?",
    a: "Oui, nous étudions chaque situation individuellement pour adapter les conditions de formation. Signalez votre situation dans le formulaire de contact (case prévue à cet effet) ou contactez directement notre référent handicap : François Schoonheere — form.action1pro@gmail.com / 07 69 05 76 73.",
  },
  {
    q: "Où puis-je acheter les livres de François Schoonheere ?",
    a: "Chaque ouvrage est disponible sur deux canaux : édition numérique PDF via Payhip (10 € TTC, liens sur la page Livres), et version papier sur Amazon pour « L’IA sans jargon » et l’« Atlas économique mondial » (liens sur la page Livres). Le petit dico de l’IA est, lui, offert.",
  },
];

export default function Faq() {
  return (
    <div data-testid="page-faq">
      <Seo
        title="FAQ — financement, délais, hygiène 14 h, tarifs — Form Action Pro"
        description="Questions fréquentes : financement OPCO (certification en cours), organisme déclaré, formation hygiène 14 h (dossier DRAAF), lieux d'intervention, délais, tarifs sur devis, accessibilité."
        path="/faq"
      />
      <PageHero
        kicker="FAQ"
        title="Questions fréquentes"
        subtitle="Financement, déclaration, hygiène réglementaire, lieux, délais, tarifs : les réponses, sans langue de bois."
      />

      <section className="bg-sable py-16">
        <div className="max-w-3xl mx-auto px-6">
          <Accordion type="single" collapsible className="space-y-4">
            {FAQ.map((f, i) => (
              <AccordionItem
                key={i}
                value={`q-${i}`}
                data-testid={`faq-item-${i + 1}`}
                className="bg-white border border-bordure rounded-lg px-6"
              >
                <AccordionTrigger
                  data-testid={`faq-question-${i + 1}`}
                  className="font-sans font-semibold text-base text-marine text-left hover:no-underline py-5"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="font-sans text-[15px] text-marine/80 leading-[1.7] pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="text-center mt-14">
            <p className="font-sans text-base text-marine/80 mb-6">
              Une autre question ? Réponse sous 48 h ouvrées.
            </p>
            <Btn to="/contact" testid="faq-cta-contact" variant="primary">
              Poser ma question
            </Btn>
          </div>
        </div>
      </section>
    </div>
  );
}
